/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetResellerInfo200ResponseReseller } from './GetResellerInfo200ResponseReseller';
import {
    GetResellerInfo200ResponseResellerFromJSON,
    GetResellerInfo200ResponseResellerFromJSONTyped,
    GetResellerInfo200ResponseResellerToJSON,
    GetResellerInfo200ResponseResellerToJSONTyped,
} from './GetResellerInfo200ResponseReseller';

/**
 * Successful response
 * @export
 * @interface GetResellerInfo200Response
 */
export interface GetResellerInfo200Response {
    /**
     * 
     */
    reseller?: GetResellerInfo200ResponseReseller;
}

/**
 * Check if a given object implements the GetResellerInfo200Response interface.
 */
export function instanceOfGetResellerInfo200Response(value: object): value is GetResellerInfo200Response {
    return true;
}

export function GetResellerInfo200ResponseFromJSON(json: any): GetResellerInfo200Response {
    return GetResellerInfo200ResponseFromJSONTyped(json, false);
}

export function GetResellerInfo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetResellerInfo200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'reseller': json['reseller'] == null ? undefined : GetResellerInfo200ResponseResellerFromJSON(json['reseller']),
    };
}

export function GetResellerInfo200ResponseToJSON(json: any): GetResellerInfo200Response {
    return GetResellerInfo200ResponseToJSONTyped(json, false);
}

export function GetResellerInfo200ResponseToJSONTyped(value?: GetResellerInfo200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reseller': GetResellerInfo200ResponseResellerToJSON(value['reseller']),
    };
}

